import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://datalogichub.com';

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const upsertCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

/**
 * Sets document title, meta description, canonical URL, and social tags
 * for the current page. Pass `path` to override the canonical path
 * (defaults to the current route).
 */
const usePageMeta = ({ title, description, path } = {}) => {
  const location = useLocation();

  useEffect(() => {
    const canonicalUrl = SITE_URL + (path ?? location.pathname);

    if (title) {
      document.title = title;
      upsertMeta('property', 'og:title', title);
      upsertMeta('name', 'twitter:title', title);
    }
    if (description) {
      upsertMeta('name', 'description', description);
      upsertMeta('property', 'og:description', description);
      upsertMeta('name', 'twitter:description', description);
    }
    upsertCanonical(canonicalUrl);
    upsertMeta('property', 'og:url', canonicalUrl);
  }, [title, description, path, location.pathname]);
};

export default usePageMeta;
